/**
 * Where an invoice is viewed: the Invoices page with that invoice's view
 * dialog open. The dialog is driven by this query parameter, so every link to
 * an invoice (a transaction's Invoice row, an applied invoice rule, the
 * duplicate dialog's "Open existing") builds its URL here.
 */
export const INVOICE_PARAM = "invoice";

export const invoicePath = (invoice: string): string =>
  `/admin/invoices?${INVOICE_PARAM}=${encodeURIComponent(invoice)}`;
